import { useTitle } from 'react-use';

import { Layout } from 'CorePackage/MainModule/components/Layout';

import { Export } from './Export';

export const ExportPage = () => {
  useTitle('Экспорт данных');

  return (
    <Layout withFooter>
      <Export />
    </Layout>
  );
};
